/*
 * Converts a string to an enum value.
 *
 * @template T - The enum type.
 * @param {T} enumObj - The enum object.
 * @param {string | null | undefined} value - The string value to convert.
 * @returns {T[keyof T] | null | undefined} - The corresponding enum value, or undefined if value is empty, or null if value can't be converted.
 */
export function convertStringToEnum<T extends Record<string, string>>(
  enumObj: T,
  value: null | string | undefined
): null | T[keyof T] | undefined {
  if (!value) {
    return undefined;
  }

  const enumValues = Object.values(enumObj) as string[];
  if (enumValues.includes(value)) {
    return value as T[keyof T];
  }

  return null;
}
